<template>
  <FormieForm :handle="handle" :enable-entries-field="true" :expiry-date="expiryDate" />
</template>

<script setup lang="ts">
interface Props {
  handle: string
  expiryDate?: string
}

defineProps<Props>()
</script>
